import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { typography } from '@clds/typography';
import { GRID_IMAGE_HEIGHT } from '~/src/root/components/ResultImageGrid/VirtualResultsGrid/const';

export const MainPageBox = styled.div`
  padding: ${(props) => props.theme.spacing.md} ${(props) => props.theme.spacing.sm};
  padding-right: 0;
  overflow: auto;
  height: calc(100% - ${(props) => props.theme.spacing.sm});
`;

export const CategoriesList = styled.ul`
  display: flex;
  list-style: none;
  flex-wrap: wrap;
  margin: 0;
  padding: 0 0 ${(props) => props.theme.spacing.md} 0;
`;

export const ListItem = styled.li`
  width: 25%;
  opacity: 0.5;
  cursor: pointer;
  transition: 0.25s ease-in-out;
  :hover {
    opacity: 1;
  }
  padding-bottom: ${(props) => props.theme.spacing.xs};
`;

export const CategoryHeader = styled.h2`
  ${typography.lg.regular};
`;

export const CategorySubheader = styled.h3`
  ${typography.md.highContrast};
  margin: 0;
  padding-bottom: ${(props) => props.theme.spacing.xs};
`;

export const CategoryThumbnailBox = styled.div`
  position: relative;
  height: 135px;
  width: 135px;
  cursor: pointer;
  margin-right: ${(props) => props.theme.spacing.md};
  margin-bottom: ${(props) => props.theme.spacing.md};
`;

export const CategoryThumbnailName = styled.div`
  width: 133px;
  position: absolute;
  bottom: 0;
  left: 0;
  height: 37px;
  background: rgba(0, 0, 0, 0.4);
  color: ${(props) => props.theme.color.white};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const GridBox = styled.div`
  width: 100%;
  overflow: hidden;
  min-height: ${GRID_IMAGE_HEIGHT}px;
  margin-left: -7px; // hacks to make grid list looks like it should
`;
